// covered-by: frontends/carrie/src/config/__tests__/askRouteTree.test.ts
import { isAskSurface, isAskSurfaceLockedByHostOrOverride } from "./askSurface";
import {
  isAskV2InPlaceEligiblePath,
  pathnameWithoutBase,
} from "./askV2InPlace";

import { askV2ChildRoutes } from "../ask-v2/routes";
import { appRoutes } from "../routes";

function bootPathname(pathname?: string): string {
  const raw =
    pathname ??
    (typeof window === "undefined" ? "/" : window.location.pathname);
  return pathnameWithoutBase(raw);
}

/**
 * Pick the V1 tickets tree or the V2 Ask tree. Isolated so tests can
 * pass the flag without constructing the singleton router.
 *
 * In-place V2 (app.puntt.ai + marker) only mounts on eligible paths.
 * Hard-loads of /tickets, /settings, /roi stay on V1. Ask hosts stay V2.
 */
export function selectChildRoutes(
  askSurface = isAskSurface(),
  pathname?: string,
  hostLocked = isAskSurfaceLockedByHostOrOverride(),
) {
  if (!askSurface) return appRoutes;
  if (hostLocked) return askV2ChildRoutes;
  if (!isAskV2InPlaceEligiblePath(bootPathname(pathname))) return appRoutes;
  return askV2ChildRoutes;
}
